export const EmployeeHoursAudit = {
	MissedClockOut: {
		Value: 1,
		Description: 'Missed Clock Out',
	},
	MissingTimeZoneConfiguration: {
		Value: 2,
		Description: 'Missing Time Zone Configuration',
	},
	ClockOutAfterJobEndDate: {
		Value: 3,
		Description: 'Clock Out After Job End Date',
	},
	EntryDeleted: {
		Value: 4,
		Description: 'Entry Deleted',
	},
	PendingRequest: {
		Value: 5,
		Description: 'Pending Request',
	},
	EntryClosed: {
		Value: 6,
		Description: 'Entry Closed',
	},
};
